import React from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ArrayHelpers, Loading, Paging, StringHelpers, SystemText } from '@salesperformanceint/e4shared';
import posthog from 'posthog-js';

import './goalSummary.css';
import WidgetBase from 'views/myDashboard/components/widgets/_base';
import Rater from 'views/user/1-2-1s/components/competencies/components/rater';

export const GoalSummary = ({
    page,
    setPage,
    period,
    periodRef,
    loading,
    goals,
    item,
    showPaging = true,
    onLoad,
    home,
    width,
    breakAt,
    setHistoric,
    navigation,
}) => {
    const user = useSelector(state => state.user.user);

    const [pageSize, setPageSize] = React.useState(3);
    const [filteredGoals, setFilteredGoals] = React.useState([]);

    React.useEffect(() => {
        goals && setFilteredGoals(goals.filter(item => item.period === period));
    }, [goals, period]);

    React.useEffect(() => {
        let size = 3;
        size = item?.h > 2 ? 3 : size;
        size = item?.h > 3 ? 6 : size;
        size = item?.h > 4 ? 9 : size;
        size = item?.h > 5 ? 12 : size;
        setPage(1);
        setPageSize(size);
    }, [item?.h]);

    React.useEffect(() => {
        onLoad?.();
    }, [goals, period]);

    if (loading)
        return (
            <span data-testid="goals-summary-loading-testid">
                <Loading />
            </span>
        );

    const periodHeaders = () => (
        <tr className="e4-data-row-container">
            <th className="">{navigation}</th>
            <th className="">
                <span
                    className="no-wrap bold text-sm progress ml10 mr10 text-right"
                    style={{ marginBottom: 0, backgroundColor: '#fff' }}
                >
                    {SystemText(`User121/Goals/GoalSummary/Buttons/Last${periodRef}`)}
                </span>
            </th>
            <th className="">
                <span
                    className="no-wrap bold text-sm progress ml10 mr10 text-right"
                    style={{ marginBottom: 0, backgroundColor: '#fff' }}
                >
                    {SystemText(`User121/Goals/GoalSummary/Buttons/This${periodRef}`)}
                </span>
            </th>
            <th className=""></th>
        </tr>
    );

    const goalProgress = (goal, i) => {
        const special = thisPeriod => {
            if (home && !thisPeriod) return null;
            let target = thisPeriod ? goal.this_Target : goal.last_Target;
            let current = thisPeriod ? goal.this_Value : goal.last_Value;
            const progress = target === 0 ? 0 : parseInt((current / target) * 100, 10);

            return (
                <span
                    key={`goal-progress-${thisPeriod}`}
                    className="text-xs-10 text-right"
                    // style={{ position: 'relative', top: '7px' }}
                >
                    <Rater
                        benchmark={progress}
                        hoverText={SystemText('User121/Goals/Percent', progress)}
                        level={StringHelpers.formatMetric(goal.format, current, user.currencySymbol)}
                        outOf={StringHelpers.formatMetric(goal.format, target, user.currencySymbol)}
                    />
                </span>
            );
        };

        const buttons = (
            <div className="table-btns">
                <button
                    data-testid="btn-edit-historic-goal"
                    className="btn btn-info btn-xs"
                    title={SystemText('User121/Goals/Edit', goal.name)}
                >
                    <i
                        className="fa fa-pencil"
                        onClick={() => {
                            setHistoric(goal);
                            posthog.capture('goals-edit-clicked', { goal: goal.name });
                        }}
                    />
                </button>
            </div>
        );

        return (
            <tr key={`goal-row${goal.id}-${i}`}>
                <td className="">{goal.name}</td>
                {width > breakAt && <td className="">{special(false)}</td>}
                <td className="">{special(true)}</td>
                <td width="1">{buttons}</td>
            </tr>
        );
    };

    const mapOver = showPaging ? ArrayHelpers.getPage(filteredGoals, page, pageSize) : filteredGoals;

    const goalsPage = (
        <div className="clear-titles">
            <table className="table table-full">
                <thead className="no-border">{!home && width > breakAt && periodHeaders()}</thead>
                <tbody className="no-top-border">{mapOver.map((g, i) => goalProgress(g, i))}</tbody>
            </table>
            {showPaging && (
                <div data-testid="paging-testid" className="text-center mt10">
                    <Paging page={page} pageSize={pageSize} recordCount={filteredGoals.length} goToPage={setPage} />
                </div>
            )}
        </div>
    );

    const chart = (
        <div data-testid="goal-summary-testid" id="goal-summary">
            {goalsPage}
        </div>
    );

    return item ? (
        <WidgetBase
            filters={null}
            chart={chart}
            item={item}
            id={'crm-goals'}
            help={null}
            hideConfig
            extra={item.extra}
            loading={loading}
        />
    ) : (
        chart
    );
};

export default withRouter(GoalSummary);
